const SPONSORSHIP_LEVEL_QUERY_PARAM = 'sponsorship_level';
const SPONSORSHIP_LEVEL_ID_PATTERN = /^level-[1-9][0-9]*$/;
const HIGHLIGHT_DURATION_MS = 3400;

export function getRequestedSponsorshipLevelID(route) {
  const rawValue = route?.query?.[SPONSORSHIP_LEVEL_QUERY_PARAM];
  const value = Array.isArray(rawValue) ? rawValue[0] : rawValue;
  if (typeof value !== 'string' || !SPONSORSHIP_LEVEL_ID_PATTERN.test(value)) {
    return null;
  }
  return value;
}

function refElement(ref) {
  return ref?.$el || ref || null;
}

export default {
  data() {
    return {
      deepLinkedSponsorshipLevelID: null,
      sponsorshipLevelHighlightTimer: null,
      sponsorshipLevelScrollTimer: null,
      sponsorshipLevelScrollHandler: null,
      sponsorshipLevelScrollEndHandler: null,
    };
  },
  computed: {
    sponsorshipLevelsForDeepLink() {
      return this.$store.getters.sponsorshipLevels || [];
    },
  },
  mounted() {
    this.focusDeepLinkedSponsorshipLevel();
  },
  beforeDestroy() {
    this.clearSponsorshipLevelHighlight();
  },
  watch: {
    sponsorshipLevelsForDeepLink() {
      this.focusDeepLinkedSponsorshipLevel();
    },
    '$route.query.sponsorship_level'() {
      this.focusDeepLinkedSponsorshipLevel();
    },
  },
  methods: {
    clearSponsorshipLevelScrollWait() {
      if (this.sponsorshipLevelScrollTimer) {
        clearTimeout(this.sponsorshipLevelScrollTimer);
        this.sponsorshipLevelScrollTimer = null;
      }
      if (this.sponsorshipLevelScrollHandler) {
        document.removeEventListener('scroll', this.sponsorshipLevelScrollHandler, true);
        this.sponsorshipLevelScrollHandler = null;
      }
      if (this.sponsorshipLevelScrollEndHandler) {
        document.removeEventListener('scrollend', this.sponsorshipLevelScrollEndHandler);
        this.sponsorshipLevelScrollEndHandler = null;
      }
    },
    clearSponsorshipLevelHighlight() {
      this.clearSponsorshipLevelScrollWait();
      if (this.sponsorshipLevelHighlightTimer) {
        clearTimeout(this.sponsorshipLevelHighlightTimer);
        this.sponsorshipLevelHighlightTimer = null;
      }
      this.deepLinkedSponsorshipLevelID = null;
    },
    waitForSponsorshipLevelScrollEnd(callback) {
      const finish = () => {
        this.clearSponsorshipLevelScrollWait();
        callback();
      };
      const scheduleFallback = () => {
        if (this.sponsorshipLevelScrollTimer) {
          clearTimeout(this.sponsorshipLevelScrollTimer);
        }
        this.sponsorshipLevelScrollTimer = setTimeout(finish, 160);
      };

      this.sponsorshipLevelScrollHandler = scheduleFallback;
      document.addEventListener('scroll', this.sponsorshipLevelScrollHandler, true);
      if ('onscrollend' in document) {
        this.sponsorshipLevelScrollEndHandler = finish;
        document.addEventListener('scrollend', this.sponsorshipLevelScrollEndHandler, { once: true });
      }
      scheduleFallback();
    },
    focusDeepLinkedSponsorshipLevel() {
      const requestedID = getRequestedSponsorshipLevelID(this.$route);
      const levelExists = this.sponsorshipLevelsForDeepLink.some(
        level => level?.externalID === requestedID
      );
      if (!requestedID || !levelExists) {
        this.clearSponsorshipLevelHighlight();
        return;
      }

      this.clearSponsorshipLevelHighlight();
      this.$nextTick(() => {
        const refs = this.$refs.sponsorshipLevelItems;
        const items = Array.isArray(refs) ? refs : (refs ? [refs] : []);
        const target = items
          .map(refElement)
          .find(element => element?.dataset?.sponsorshipLevelId === requestedID);
        if (!target) {
          this.clearSponsorshipLevelHighlight();
          return;
        }

        this.waitForSponsorshipLevelScrollEnd(() => {
          if (getRequestedSponsorshipLevelID(this.$route) !== requestedID) {
            return;
          }
          this.deepLinkedSponsorshipLevelID = requestedID;
          this.sponsorshipLevelHighlightTimer = setTimeout(() => {
            this.deepLinkedSponsorshipLevelID = null;
            this.sponsorshipLevelHighlightTimer = null;
          }, HIGHLIGHT_DURATION_MS);
        });
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    },
  },
};
